export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
export const GET_ALL_ACCOUNTS = 'GET_ALL_ACCOUNTS'
export const GET_SINGLE_ACCOUNT = 'GET_SINGLE_ACCOUNT'
export const GET_ALL_SELLERS = 'GET_ALL_SELLERS'
export const GET_ALL_PG_ACCOUNTS = 'GET_ALL_PG_ACCOUNTS'
export const SET_RESPONSE = 'SET_RESPONSE'
export const GET_REVENUE_CHARGES = 'GET_REVENUE_CHARGES'
export const GET_REVENUE_CHARGE_FEES = 'GET_REVENUE_CHARGE_FEES'
